:host {
  display: block;
  box-sizing: border-box;
}

:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}

.link {
  display: flex;
  align-items: center;
}

:host(:not([dir="rtl"])) .link {
  padding-right: 10px;
}

:host([dir="rtl"]) .link {
  padding-left: 10px;
}

.link .highlight-naming .accent {
  font-weight: bold;
}